// extracted by mini-css-extract-plugin
module.exports = {"header":"AccordionItem_header__ndBU7","collapsed":"AccordionItem_collapsed__FwsmK","body":"AccordionItem_body__S_jBT","item":"AccordionItem_item__vnQxN"};